import type { IBulkActionPayload, IBulkJob } from "helpers/utils/bulk-manager";
import { BulkActionType, BulkActionProcessingStatus } from "helpers/utils/bulk-manager";
import { BULK_MANAGER } from "../../constants/action-types";
import fetch from "lib/fetch";
import Globalize from "globalize";

function fetchData(brandId: string, userId: string) {
    return fetch(`/api/v3.1/brand/${brandId}/bulk-catalog/user/${userId}`, {
        method: "GET",
        headers: {
            "Active-Brand": brandId,
        },
    });
}

export const openBulkManager = (type: string) => ({ type: BULK_MANAGER.OPEN, payload: type });
export const closeBulkManager = () => ({ type: BULK_MANAGER.CLOSE });
export const addBulkAction = (payload: IBulkActionPayload) => ({ type: BULK_MANAGER.ADD, payload });
export const removeBulkAction = (id: string) => ({ type: BULK_MANAGER.REMOVE, payload: { id } });
export const setBulkJob = (payload: IBulkJob) => ({ type: BULK_MANAGER.SET_BULK_JOBS, payload });

export const fetchBulkActions = (brandId: string, userId: string, linesheets_are_catalogs: boolean) => (dispatch) => {
    return fetchData(brandId, userId)
        .then((response) => response.json())
        .then((data: IBulkJob[]) => {
            const latestBulkJob = data.pop();

            dispatch(setBulkJob(latestBulkJob));
            latestBulkJob.jobs.forEach((job) => {
                const actionPayload: IBulkActionPayload = {
                    id: job.ref,
                    brandId: latestBulkJob.brand_id,
                    name: job.description.split(".")[0].replace("_", " "),
                    status: job.complete ? BulkActionProcessingStatus.SUCCESS : BulkActionProcessingStatus.PROCESSING,
                    type: BulkActionType.DOWNLOAD,
                };

                dispatch(addBulkAction(actionPayload));
            });

            const label = linesheets_are_catalogs
                ? Globalize.formatMessage("catalogs")
                : Globalize.formatMessage("linesheets");

            // fix hardcode
            dispatch(openBulkManager(label));
        })
        .catch((error) => {
            // do nothing
        });
};
